(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-landing-7-raisons"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('mijota-landing-seven')) {
    class MijotaLandingSeven extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = Array.from(this.querySelectorAll('.mijota-l7__video'));
        this.ratios = new Map(this.videos.map((video) => [video, 0]));
        this.setupVideos();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.videoObserver?.disconnect();
      }

      setupVideos() {
        const signal = this.abortController.signal;

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
            this.updateAutoplay();
          }, { threshold: [0, 0.35, 0.58, 0.75, 1] });
          this.videos.forEach((video) => this.videoObserver.observe(video));
        }

        this.motionQuery.addEventListener?.('change', () => this.updateAutoplay(), { signal });
        if (this.motionQuery.matches) this.videos.forEach((video) => this.pause(video));
      }

      pause(video) {
        video.pause();
      }

      playOnly(video) {
        this.videos.forEach((candidate) => {
          if (candidate !== video) this.pause(candidate);
        });
        if (!video.paused) return;
        // Les videos sont en preload="none" : elles n'ont aucune donnee tant
        // qu'on ne le demande pas, et un play() seul les laisse a l'arret.
        // Verifie le 26/08/2026 : en metadata elles demarraient, en none elles
        // restaient figees a zero. On amorce donc le chargement nous-memes,
        // puis on lance des qu'il y a de quoi jouer.
        if (video.readyState === 0) {
          video.load();
          video.addEventListener('loadeddata', () => {
            if (this.ratios.get(video) > 0) video.play().catch(() => {});
          }, { once: true });
          return;
        }
        video.play().catch(() => {});
      }

      updateAutoplay() {
        if (this.motionQuery.matches) {
          this.videos.forEach((video) => {
            this.pause(video);
            if (video.currentTime > 0) video.load();
          });
          return;
        }
        let bestVideo = null;
        let bestRatio = 0;
        this.ratios.forEach((ratio, video) => {
          if (ratio >= 0.58 && ratio > bestRatio) {
            bestVideo = video;
            bestRatio = ratio;
          }
        });
        if (bestVideo) this.playOnly(bestVideo);
        else this.videos.forEach((video) => this.pause(video));
      }

    }

    customElements.define('mijota-landing-seven', MijotaLandingSeven);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-landing-cart-host"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // La pastille suit une seule source de vérité : /cart.js.
    //
    // On ne lit pas `event.detail.data.itemCount`. Sur un ajout depuis une fiche
    // produit, le thème y met la QUANTITÉ AJOUTÉE et non le total du panier
    // (product-form.js le confirme, et cart-icon.js additionne au lieu de
    // remplacer quand la source est 'product-form-component'). Pire, un ajout
    // qui échoue émet quand même l'événement avec didError. Se fier à ce nombre
    // ferait apparaître la pastille sur un panier resté vide.
    function majPastille(nombre) {
      var racine = document.querySelector('[data-mijota-landing-cart-host]');
      if (!racine) return;
      if (nombre > 0) racine.classList.add('mijota-landing-cart-host--actif');
      else racine.classList.remove('mijota-landing-cart-host--actif');
    }

    var enCours = false;

    function relire() {
      if (enCours) return;
      enCours = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (panier) { majPastille(panier.item_count); })
        .catch(function () {})
        .then(function () { enCours = false; });
    }

    document.addEventListener('cart:update', function () { setTimeout(relire, 60); });
    document.addEventListener('cart:error', relire);
    document.addEventListener('discount:update', relire);

    // Liquid pose déjà la classe au rendu, mais une page servie depuis le cache
    // du navigateur porte l'état d'une visite précédente. On resynchronise au
    // chargement et au retour arrière, comme le fait le compteur du thème.
    relire();
    window.addEventListener('pageshow', function (e) { if (e.persisted) relire(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-product-hero"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.mijota-pdp').forEach(function(root) {
      var slides = root.querySelectorAll('[data-slide-index]');
      var thumbs = root.querySelectorAll('[data-thumb-index]');
      var navs = root.querySelectorAll('[data-nav]');
      var qtyInput = root.querySelector('.mijota-pdp__qty-input');
      var qtyBtns = root.querySelectorAll('[data-qty]');
      var current = 0;
      var total = slides.length;

      function activate(i) {
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        current = i;
        slides.forEach(function(s) {
          var idx = parseInt(s.getAttribute('data-slide-index'), 10);
          s.classList.toggle('is-active', idx === current);
          s.setAttribute('aria-current', idx === current ? 'true' : 'false');
        });
        thumbs.forEach(function(t) {
          var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
          t.classList.toggle('is-active', idx === current);
        });
      }

      thumbs.forEach(function(t) {
        t.addEventListener('click', function() {
          activate(parseInt(t.getAttribute('data-thumb-index'), 10));
        });
      });

      navs.forEach(function(n) {
        n.addEventListener('click', function() {
          var dir = n.getAttribute('data-nav');
          activate(dir === 'next' ? current + 1 : current - 1);
        });
      });

      qtyBtns.forEach(function(b) {
        b.addEventListener('click', function() {
          if (!qtyInput) return;
          var v = parseInt(qtyInput.value, 10) || 1;
          var dir = b.getAttribute('data-qty');
          var n = dir === 'increment' ? v + 1 : v - 1;
          if (n < 1) n = 1;
          if (n > 99) n = 99;
          qtyInput.value = n;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mijota-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PICTOS = {
      fabrication: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18M5 21V8l7-5 7 5v13M9 21v-6h6v6"/></svg>',
      clients: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1M17 11l2 2 4-4"/></svg>',
      livraison: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7zM7.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM17.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/></svg>'
    };

    function initAnnonces() {
      document.querySelectorAll('[data-mijota-annonce]').forEach(function (racine) {
        if (racine.dataset.annonceReady === 'true') return;
        racine.dataset.annonceReady = 'true';

        var source = racine.querySelector('[data-mijota-annonce-source]');
        var ligne = racine.querySelector('[data-mijota-annonce-ligne]');
        var picto = racine.querySelector('[data-mijota-annonce-picto]');
        var texte = racine.querySelector('[data-mijota-annonce-texte]');
        if (!source || !ligne || !texte) return;

        var messages = [];
        source.querySelectorAll('span').forEach(function (s) {
          var t = (s.textContent || '').trim();
          if (t) messages.push({ texte: t, picto: s.getAttribute('data-picto') });
        });
        if (!messages.length) return;

        var i = 0;

        function poser(index) {
          i = (index + messages.length) % messages.length;
          var m = messages[i];
          texte.textContent = m.texte;
          if (picto) picto.innerHTML = PICTOS[m.picto] || '';
          ligne.removeAttribute('data-sort');
        }

        poser(0);
        if (messages.length < 2) return;

        var duree = parseInt(racine.getAttribute('data-rotation'), 10) || 4000;
        var minuteur = setInterval(function () {
          ligne.setAttribute('data-sort', 'true');
          setTimeout(function () { poser(i + 1); }, 350);
        }, duree);

        racine.addEventListener('shopify:section:unload', function () { clearInterval(minuteur); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnonces, { once: true });
    } else {
      initAnnonces();
    }
    document.addEventListener('shopify:section:load', initAnnonces);
  })();

  } catch(e) { console.error(e); }
})();
})();
